import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { history } from "./helpers/history";
import "./App.scss";
import { connect } from "react-redux";
import FormLayout from "./cms/areas/form/containers/FormLayout/FormLayout";
import PostFormLayout from "./cms/areas/form/containers/PostFormLayout/PostFormLayout";
import TemplateLayout from "./cms/areas/template/containers/TemplateLayout/TemplateLayout";
import PageBug from "./views/Pages/PageBug/PageBug";
import RedirectUser from "./RedirectUser";
import ArticleFeed from "./cms/areas/page/plugins/article/containers/ArticleFeed";
import ArticleEditor from "./cms/areas/page/plugins/article/containers/ArticleEditor/ArticleEditor";
import Dibs from "./payments/CardPayment/Dibs/Dibs";
import Nets from "./payments/CardPayment/Nets/Nets";
import PageEditorLayout from "./cms/areas/page/container/Editor/Layout/PageEditorLayout";
import PageViewLayout from "./cms/areas/page/container/View/Layout/PageViewLayout";
import { ProvideBrowserOptions } from "./system/BrowserAgent/ProvideBrowserOptions";
import { ScanView } from "./checkpoint/ScanView";
import { SplashScreen } from "./cms/components/UI/SplashScreen/SplashScreen";
import CheckinView from "./checkpoint/CheckinView";
import LinkTracker from "./system/LinkTracker/LinkTracker";
import EmailEditor from "./cms/areas/email/containers/EmailEditor/EmailEditor";

import MeetingEditorLayout from "./cms/areas/meeting/container/EditorLayout/MeetingEditorLayout";
import Layout from "./cms_2.0/Layout";
import QRList from "./QRList/QRList";
import PrinterClients from "./views/Pages/PrinterClients/PrinterClients";
import Stripe from "./cms_2.0/payment/Stripe/Stripe";

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Pages
const Page404 = React.lazy(() => import("./views/Pages/Page404"));
const Page500 = React.lazy(() => import("./views/Pages/Page500"));

class App extends Component {
  componentDidMount() {
    // this.props.dispatch(systemLabelActions.getAllGroups());
  }
  directToInadraHomePage = () => {
    window.location.replace("https://jirango.com/");
  };
  render() {
    return (
      <Router history={history}>
        <React.Suspense fallback={loading()}>
          {this.props.globals.isLoading ? <SplashScreen /> : null}
          <Switch>
            <Route exact path="/react" name="Redirect to react" render={(props) => <RedirectUser {...props} />} />
            <Route exact path="/ref/:refNo" name="Login Page" render={(props) => <LinkTracker {...props} />} />
            <Route exact path="/login" name="Login Page" render={(props) => <ExternalRedirect exact={true} path={"/login"} link={"https://jirango.com/admin"} />} />
            <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
            <Route exact path="/provide-browser-options" name="Select Browser" render={(props) => <ProvideBrowserOptions {...props} />} />
            <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
            <Route exact path="/prev/:id" name="ContentLayout" render={(props) => <Layout {...props} />} />
            <Route exact path="/web/:id" name="ContentLayout" render={(props) => <Layout {...props} />} />
            <Route exact path="/web/card/:id" name="NETS" render={(props) => <Nets {...props} />} />
            <Route exact path="/web/stripe/:id" name="Stripe" render={(props) => <Stripe {...props} />} />
            <Route exact path="/page-error" name="Page 500" render={(props) => <PageBug {...props} />} />
            <Route exact path="/react" name="Redirect to react" render={(props) => <RedirectUser {...props} />} />
            <Route exact path="/provide-browser-options" name="Select Browser" render={(props) => <ProvideBrowserOptions {...props} />} />
            <Route exact path="/page-error" name="Page 500" render={(props) => <PageBug {...props} />} />
            <Route
              exact
              path="/cms/page/:id"
              name="Page Editor"
              render={(props) => (localStorage.getItem("user") ? <PageEditorLayout {...props} /> : <ExternalRedirect exact={true} link={"https://jirango.com/admin"} />)}
            />
            <Route exact path="/checkin/:id" name="Check in view" render={(props) => <CheckinView {...props} />} />
            <Route
              exact
              path="/cms/meeting/:id"
              name="Meeting Editor"
              render={(props) => (localStorage.getItem("user") ? <MeetingEditorLayout {...props} /> : <ExternalRedirect exact={true} path={"/cms/meeting/:id"} link={"https://jirango.com/admin"} />)}
            />
            <Route exact path="/checkin/:id" name="Check in view" render={(props) => <CheckinView {...props} />} />
            <Route
              exact
              path="/cms/form/:id"
              name="Form Editor"
              render={(props) => (localStorage.getItem("user") ? <FormLayout {...props} /> : <ExternalRedirect exact={true} path={"/cms/form/:id"} link={"https://jirango.com/admin"} />)}
            />
            <Route
              exact
              path="/cms/email/:id"
              name="Form Editor"
              render={(props) => (localStorage.getItem("user") ? <EmailEditor {...props} /> : <ExternalRedirect exact={true} path={"/cms/form/:id"} link={"https://jirango.com/admin"} />)}
            />
            <Route
              exact
              path="/cms/template/:id"
              name="Template Editor"
              render={(props) => (localStorage.getItem("user") ? <TemplateLayout {...props} /> : <ExternalRedirect exact={true} path={"/cms/template/:id"} link={"https://jirango.com/admin"} />)}
            />
            <Route exact path={"/register/:id"} name="Form" render={(props) => <PostFormLayout {...props} />} />
            <Route exact path={"/register/dibs/:id"} name="Dibs" render={(props) => <Dibs {...props} />} />
            <Route exact path={"/survey/:id"} name="Survey" render={(props) => <PostFormLayout {...props} />} />
            <Route exact path={"/checkpoint/scan"} name="Checkpoint" render={(props) => <ScanView {...props} />} />
            <Route exact path={"/p/:id"} name="Page" render={(props) => <PageViewLayout {...props} />} />
            <Route exact path={"/news/articles/:id"} name="Article Feed" render={(props) => <ArticleFeed {...props} />} />
            <Route exact path={"/articles/edit/:id"} name="Article Feed" render={(props) => <ArticleEditor {...props} />} />
            <Route exact path={"/articles/edit/"} name="Article Feed" render={(props) => <ArticleEditor {...props} />} />
            <Route
              exact
              path={"/printers/:id"}
              name="Printer Clients"
              render={(props) => (localStorage.getItem("user") ? <PrinterClients {...props} /> : <ExternalRedirect exact={true} path={"/"} link={"https://jirango.com/admin"} />)}
            />
            <Route
              exact
              path={"/qr-list/:id"}
              name="QR-List"
              render={(props) => (localStorage.getItem("user") ? <QRList {...props} /> : <ExternalRedirect exact={true} path={"/cms/form/:id"} link={"https://jirango.com/admin"} />)}
            />
            {/* <Route path="/" name="Home" render={(props) => <ExternalRedirect exact={true} path={"/"} link={"https://jirango.com/"} />} /> */}
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}
const ExternalRedirect = (props) => {
  return (
    <Route
      render={() => {
        window.location.replace(props.link);
        return null;
      }}
    />
  );
};

function mapStateToProps(state) {
  return {
    globals: state.globals,
  };
}
export default connect(mapStateToProps)(App);
